﻿import $ from "jquery";

const filetypes = /\.(pdf|doc.*|xls.*|ppt.*|ashx)$/i;
$("a").each(function() {
    var href = $(this).attr("href");
    if (href && href.match(filetypes)) {
        $(this).on("click",
            function () {
                ga("send",
                    {
                        hitType: "event",
                        eventCategory: "download",
                        eventAction: "click",
                        eventLabel: href
                    });
            });
    }
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/utils/downloadTracker.js
// module id = 14
// module chunks = 1